/**
 * Variant Select Initializer
 * Converts [variant-select] divs into functional variant pickers
 * Matches TypeScript-master directive behavior using Web Components
 */

function initializeVariantSelect() {
  const variantSelectElements = document.querySelectorAll('[variant-select]:not([data-initialized])');
  
  variantSelectElements.forEach((element) => {
    // Mark as initialized
    element.setAttribute('data-initialized', 'true');

    // Get necessary data from context
    const section = element.closest('.shopify-section');
    const productUrl = window.location.pathname;
    const sectionId = section?.id || '';
    
    // Find product ID from form or other source
    const form = /** @type {HTMLElement} */ (element.querySelector('form') || document.querySelector('[data-product-id]'));
    const productId = form?.dataset?.productId || /** @type {HTMLElement} */ (document.querySelector('[data-product-id]'))?.dataset?.productId || '';

    // Set required data attributes
    element.setAttribute('data-template-product-match', document.body.classList.contains('template-product') ? 'true' : 'false');
    element.setAttribute('data-product-url', productUrl);
    element.setAttribute('data-section-id', sectionId);
    element.setAttribute('data-product-id', productId);

    // Change the element tag to variant-picker
    const variantPicker = document.createElement('variant-picker');
    
    // Copy all attributes
    Array.from(element.attributes).forEach(attr => {
      variantPicker.setAttribute(attr.name, attr.value);
    });

    // Move all children
    while (element.firstChild) {
      variantPicker.appendChild(element.firstChild);
    }

    // Replace the element
    element.replaceWith(variantPicker);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeVariantSelect);
} else {
  initializeVariantSelect();
}

// Re-initialize on section renders (theme editor, AJAX)
document.addEventListener('shopify:section:load', initializeVariantSelect);

export default initializeVariantSelect;

